import e from "react";
import { Icon as r } from "@chakra-ui/react";
const m = ({ as: o, ...t }) => /* @__PURE__ */ e.createElement(r, { as: o, ...t });
export {
  m as Icon
};
